import {
  AuthContextLoginParams,
  LoggedInUserInfo,
  UserProfile,
} from '../../models';

export enum ROUTES {
  expired_subscription = '/auth/expired-subscription',
  login = '/auth/login',
  signup = '/auth/signup',
  signupCreatePassword = '/auth/create-password',
  signup_trial = '/auth/signup/trial',
  signup_welcomeBack = '/auth/signup/welcome-back',
  signup_subscription_paywall = '/auth/signup/subscription-paywall',
  signup_verification = '/auth/signup/verification',
  change_pwd_signup = '/auth/signup/change-password',
}
//Whitelisted pages to pass subscription wall
export const WHITELISTED_PAGES_FOR_NON_SUBSCRIBED: string[] = [
  ROUTES.signup_verification,
  ROUTES.expired_subscription,
  ROUTES.login,
  ROUTES.signup,
  ROUTES.signupCreatePassword,
  ROUTES.signup_trial,
  ROUTES.signup_welcomeBack,
  ROUTES.signup_subscription_paywall,
  ROUTES.change_pwd_signup,
];

export interface IAuthContext {
  accessToken?: string;
  user?: LoggedInUserInfo;
  login: (
    loginParams: AuthContextLoginParams,
    redirect?: string,
    isOnSignup?: boolean
  ) => Promise<void>;
  logout: (redirect?: string | boolean) => Promise<void>;
  isAuthenticated: () => boolean;
  isSubscribed: () => void;
  setRememberMe: (rememberMe: boolean) => void;
  loading: boolean;
  setUser: (user: LoggedInUserInfo) => void;
  updateUserInfo?: (
    userProfile: UserProfile,
    cb?: () => void
  ) => Promise<UserProfile>;
  updateAvatar?: (avatar: File, cb?: () => void) => Promise<UserProfile>;
  fetchUserInfo: () => void;
  role: {
    isSuperAdmin: boolean;
    isSchoolAdmin: boolean;
    isTeacher: boolean;
    isStudent: boolean;
  };
}

export interface AuthProviderProps {
  children: React.ReactNode;
  homeRoute: string;
  loginRoute: string;
  app: 'ADMIN' | 'PLATFORM';
}
